import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Footer } from "../../components/Footer";
import Header from "../../components/Header";
import patient from "../../assets/img/patient.jpg";
import success from "../../assets/img/success.png";
import { useEffect, useRef, useState } from "react";
import { CallWithAuth, CallWithFaceMatchAuth } from "../../action/apiActions";
import {
  GET_PATIENT_ASSESMENT,
  GET_PATIENT_RELATIVES_API_URL,
  PATIENT_ASSESSMWNT_SUBMIT,
  PATIENT_FACE_IMAGE_MATCH_API,
  SEND_MAIL_PATIENT_RELATIVES_API_URL,
  SEND_PATIENT_ASSESMENT,
  UPLOAD_CLICNICAL_INTAKE_DOC,
} from "../../action/apiPath";
import { errorMessageCreate, fileName, textRetriever } from "../../util/custom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { showToast, ToastContainer } from "../../util/toastHelper";
import PatientHeader from "../../components/patient/PatientHeader";
import { PatientFooter } from "../../components/patient/PatientFooter";
import Webcam from "react-webcam";
import { base64ToFile } from "../../util/base64ToFile";
import axios from "axios";

const MySwal = withReactContent(Swal);

const PatientAssesmentSubmitPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = useState();
  const [selectedLinks, setSelectedLinks] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [links, setLinks] = useState([""]); // Start with one input
  const [error, setError] = useState("");
  const [assesmentLoading, setAssesmentLoading] = useState(false);
  const [hasSubmitByPatient, setHasSubmitByPatient] = useState(false);
  const [showthankyouMsg, setThankyouMsg] = useState(false);
  const [patient_face_image_consent, setPatientFaceImageConsent] =
      useState(false);
  const webcamRef = useRef(null);
  const [hasFaceMatchConfirmation, setHasFaceMatchConfirmation] =
      useState(false);

  const [isConfirmed, setIsConfirmed] = useState(null);
  const [face_image, setFaceImage] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
      
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenParam = params.get("token");
    if (tokenParam) {
      setToken(tokenParam);
    }
  }, [location]);

  useEffect(() => {
    if (token) getAssesmentFromSubmit();
  }, [token]);

  useEffect(() => {
    let _token = (new URLSearchParams(location.search)).get("token");
    if (!_token) _token = localStorage.getItem("accessToken");
    if (!_token) navigate("/login");
  }, []);

  const getAssesmentFromSubmit = async () => {
    let response = await CallWithAuth("GET", GET_PATIENT_ASSESMENT, {}, token);
    let message = errorMessageCreate(response?.res?.data?.message);

    if (response?.res?.data?.statusCode === 200) {
      const allChecked =
        response.res.data.data?.assessments?.length > 0 &&
        response.res.data.data?.assessments.every((link) => link.is_submitted);

      if (allChecked) {
        showToast("success", "All links are already submitted.");
        setHasSubmitByPatient(true);
      } else {
        showToast("success", message);
        
        setPatientFaceImageConsent(
          response?.res?.data?.data?.patient?.patient_face_image_consent
        );
        setHasFaceMatchConfirmation(
          !response?.res?.data?.data?.patient?.patient_face_image_consent
        );

        setLinks(response.res.data.data?.assessments);
      }
    } else {
      showToast("error", message);
    }
    setIsLoading(false);
  };

  const handleCheckboxChange = (id) => {
    setLinks((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, isChecked: !item.isChecked } : item
      )
    );
  };

  const handleConfirmationChange = (value) => {
    setIsConfirmed(value);
  };

  const handleUploadDocFile = async (file) => {
    try {
      const formdata = new FormData();
      formdata.append("file", file);

      const body = formdata;

      return await CallWithAuth("POST", UPLOAD_CLICNICAL_INTAKE_DOC, body, (new URLSearchParams(location.search)).get("token"));
    } catch (err) {}
  };

  const capture = async (e) => {
    e.preventDefault();
    const image = webcamRef.current?.getScreenshot();
    if (image) {
      setIsLoading(true);
      let fileName = "face_image.jpeg";
      let face_image = await base64ToFile(image, fileName, "image/jpeg");
      const response = await handleUploadDocFile(face_image);
      let message = errorMessageCreate(response?.res?.data?.message);
      if (response?.res?.data?.statusCode === 200) {
        // console.log("response==>", response.res.data.data.file_url);
        setFaceImage(response.res.data.data.file_url);
          
        const responseFaceImg = await CallWithAuth(
          "POST",
          PATIENT_FACE_IMAGE_MATCH_API,
          {
            face_image: response.res.data.data.file_url,
          },
          (new URLSearchParams(location.search)).get("token")
        );
        let message = errorMessageCreate(responseFaceImg?.res?.data?.message);
        if (responseFaceImg?.res?.data?.statusCode === 200) {
          setImageSrc(image);
          setHasFaceMatchConfirmation(true);
          showToast("success", message);
        } else {
          showToast("error", message);
        }
      } else {
        showToast("error", message);
      }
      setIsLoading(false);
    }
  };

  const handleSubmit = async () => {
    setAssesmentLoading(true);
    if (isConfirmed) {
      if (!imageSrc) {
        showToast("error", "Please take a profile photo of your face.");
        return;
      }
    }
    try {
      const notSubmittedLinks = links.filter((link) => !link.is_submitted); // check if any link is not submitted

      const allChecked =
        notSubmittedLinks.length > 0 &&
        notSubmittedLinks.every((link) => link.isChecked);
      if (allChecked) {
        let assesmentIds = [];
        notSubmittedLinks?.map((linkObj, index) => {
          assesmentIds.push(linkObj.id);
        });

        let response = await CallWithAuth("PATCH", PATIENT_ASSESSMWNT_SUBMIT, {
          assessmentIds: assesmentIds,
        }, token);
        let message = errorMessageCreate(response?.res?.data?.message);

        if (response?.res?.data?.statusCode === 200) {
          setThankyouMsg(true);
          setHasSubmitByPatient(true);
        } else {
          showToast("error", message);
          setTimeout(() => {
            navigate("/");
          }, 1000);
        }
      } else {
        showToast("error", "Please select all links to submit.");
      }
    } catch (error) {
      console.error("Error submitting link:", error);
    }
    setAssesmentLoading(false);
  };

  const notSubmittedLinks = links.filter((link) => !link.is_submitted); // check if any link is not submitted

  const allChecked =
    notSubmittedLinks.length > 0 &&
    notSubmittedLinks.every((link) => link.isChecked);
    
  return (
    <>
      <PatientHeader />

      {isLoading && (
        <>
          <div className="full-page-loader">
            <div className="loader"></div>
          </div>
        </>
      )}

      <section className="clinical-intake-form">
        <div className="container my-5 pt-5">
          {hasSubmitByPatient ? (
            <>
              <h1>Successfully submitted the Assessment</h1>
            </>
          ) : (
            <>
              <div className="col-12">
                <h3>PsychScribe: Assessment Intake Form</h3>
              </div>
              <div className="col-12 text-center">
                <span className="text-primary">
                  Click the box on the left hand side of the online assessment link once complete for submission
                </span>
              </div>
            </>
          )}
        {!hasSubmitByPatient && (<>
          
          <div className="col-lg-10 mx-auto">
            <div className="row">
               {patient_face_image_consent && (
                  <>
                    <div>
                      <p style={{ fontWeight: "bold" }}>
                        Consent is required to upload your photo for face
                        verification. Please provide your consent to proceed.
                      </p>
                      <label>
                        <input
                          type="radio"
                          name="confirmation"
                          value="yes"
                          onChange={() => handleConfirmationChange(true)}
                        />{" "}
                        Yes
                      </label>
                    </div>
                  </>
                )}

                {isConfirmed && (
                  <>
                    <div>
                      <Webcam
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        width={640}
                        height={480}
                        onUserMediaError={() =>
                          alert(
                            "Camera access denied. Please check your browser settings."
                          )
                        }
                        videoConstraints={{
                          width: 1280,
                          height: 720,
                          facingMode: "user",
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={capture}
                        style={{ display: "block" }}
                      >
                        Capture Photo
                      </button>
                      {imageSrc && (
                        <div>
                          <h3>Captured Image:</h3>
                          <img src={imageSrc} alt="Captured" />
                        </div>
                      )}
                    </div>
                  </>
                )}

                {hasFaceMatchConfirmation && (
                  <>
                    {!hasSubmitByPatient &&
                    links.map((linkObj) => (
                      <>
                        <div
                          key={linkObj.id}
                          className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mt-4"
                        >
                          <div className="d-flex justify-content-between align-items-center gap-2 customdesign">
                            {/* Checkbox */}
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={linkObj.isChecked || linkObj.is_submitted}
                              disabled={linkObj.is_submitted}
                              onChange={() => handleCheckboxChange(linkObj.id)}
                            />

                            {/* Clickable Link */}
                            <a
                              href={linkObj.assessment_link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-primary flex-grow-1"
                              style={{ wordBreak: "break-word" }}
                            >
                              {linkObj.assessment_link}
                            </a>
                          </div>
                        </div>
                      </>
                    ))}                
                  </>
                )}
               
              {allChecked && !hasSubmitByPatient && (
                <>
                  <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 mt-4 text-center">
                    <button
                      disabled={!allChecked} // Enable only if all checkboxes are checked
                      onClick={() => handleSubmit()}
                      className="btn btn-primary"
                    >
                      {assesmentLoading ? (
                        <>
                          Assessment Submit{" "}
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </>
                      ) : (
                        "Assessment Submit"
                      )}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
          </>
        )}

        </div>
      </section>

      <ToastContainer />
      <PatientFooter is_relative={true} />
    </>
  );
};
export default PatientAssesmentSubmitPage;
